<template>
  <div>
    <v-dialog v-model="show" @click:outside="closeDialog">

      <v-card>
        <v-card-title>
          <v-progress-linear indeterminate color="teal" v-if="loading"></v-progress-linear>

          <strong>{{ $t('views.dialogOrderDetail.title') }} |</strong>&nbsp;#{{ paymentOrderId }}
        </v-card-title>

        <v-card-text>
          <v-row>
            <!-- BASIC DATA ITERATOR FOR PAYMENT ORDER INFO -->
            <v-col cols="6">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.ddpgOrderId') }}</td>
                      <td>{{ order.payment_order_id }}</td>
                    </tr>
                    <tr v-if="order.organization_name"><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.organization') }}</td>
                      <td>{{ order.organization_name }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.merchant') }}</td>
                      <td>{{ order.merchant_name }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.merchantOrderId') }} / {{ $t('views.dialogOrderDetail.ddpayOrderId') }} </td>
                      <td>{{ order.merchant_order_number }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.amount') }}</td>
                      <td>{{ order.currency }}${{ Number(order.amount).toLocaleString() }}</td>
                    </tr>
                    <!-- <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paidVia') }}</td>
                      <td>{{ order.payment_type }}</td>
                    </tr> -->
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.status') }}</td>
                      <td>{{ order.status }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.createdAt') }}</td>
                      <td>{{ order.created_at }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <!-- MORE DATA ITERATOR FOR PAYMENT ORDER INFO -->
            <v-col cols="6">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paymentService') }}</td>
                      <td>
                        <div v-if="getPaymentServiceIcon(order.payment_service)">
                          <img :src="getPaymentServiceIcon(order.payment_service)" style="height: 28px;">
                        </div>
                        <div v-else>{{ order.payment_service }}</div>
                      </td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paymentType') }}</td>
                      <td>
                        <div v-if="getPaymentServiceIcon(order.payment_service_type)">
                          <img :src="getPaymentServiceIcon(order.payment_service_type)" style="height: 28px;">
                        </div>
                        <div v-else>{{ order.payment_service_type }}</div>
                      </td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.paymentServiceName') }}</td>
                      <td>{{ order.payment_service_name }}</td>
                    </tr>
                    <tr><td class="font-weight-medium">{{ $t('views.dialogOrderDetail.useTds') }}</td>
                      <td>{{ order.use_tds == 1? 'Yes': 'No' }}</td>
                    </tr>
                    <tr v-if="user.level === 'superadmin'"><td class="font-weight-medium">Request Context (for debug)</td>
                      <td>
                        <a @click="showRequestContext = true" v-if="!showRequestContext">Show</a>
                        <span v-if="showRequestContext">{{ order.request_context }}</span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>

            <!-- LIST OF TRANSACTIONAL HISTORY -->
            <v-col cols="12">
              <h4 class="text-center">{{ $t('views.dialogOrderDetail.transactionalHistory') }}</h4>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th v-for="col in transactionSchema" :key="col.value">
                        {{ col.text }}
                      </th>
                      <th>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="t in transactions" :key="t['id']">
                      <td v-for="col in transactionSchema" :key="col.value">
                        {{ t[col.value] }}
                      </td>
                      <td width="20%">
                        <v-btn fab x-small color="info" @click="showTransactionDetail(t)">
                          <v-icon>mdi-information</v-icon>
                        </v-btn>
                        <v-btn v-if="['paid', 'captured'].indexOf(t['status']) >= 0"
                          rounded small color="error" class="ml-2" @click="requestRefund(t)">
                          <v-icon left>mdi-cash-refund</v-icon>
                          {{ $t('views.dialogOrderDetail.refund') }}
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <!-- EXPANSION - TRANSACTION CONTEXT -->
              <v-expand-transition>
                <v-card outlined v-show="expansion.detail.show" class="ma-2 pa-2">
                  <v-card-text>
                    {{ JSON.stringify(expansion.detail.context, null, 2) }}
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click="expansion.detail.show = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </v-expand-transition>
            </v-col>

          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { GetIconMixin } from '@/mixins/get-icons';
import axios from 'axios';

export default {
  name: 'OrderDetailDialog',
  props: {
    show: Boolean,
    paymentOrderId: String
  },
  mixins: [
    GetIconMixin
  ],

  mounted() {

  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    fetchPaymentOrderInfo() {
      this.showRequestContext = false;
      this.loading = true;
      axios.get(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/orders/${this.paymentOrderId}`
        + `?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
      )
      .then(response => {
        this.order = response.data;
      })
      .catch(err => {
        console.error(`Failed to fetch payment order information.`, err.response);
        this.$notify({
          text: `Failed to fetch payment order information.`,
          type: 'error', 
        });
      })
      .finally(() => {
        this.loading = false;
      });
    },
    fetchTransactionHistory() {
      axios.get(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/orders/${this.paymentOrderId}/history`
        + `?timeFormat=${encodeURIComponent('YYYY/M/D h:mm:ssA')}`
      )
      .then(response => {
        this.transactions = response.data;
      })
      .catch(err => {
        console.error(`Failed to fetch transactional history.`, err.response);
        this.$notify({
          text: `Failed to fetch transactional history.`,
          type: 'error', 
        });
      });
    },

    showTransactionDetail(_transaction) {
      this.expansion.detail.context = _transaction['context'];
      this.expansion.detail.show = true;
    },

    requestRefund() {
      if (!confirm(`Sure you want to refund for $${this.order['amount']}? This cannot be undone.`))
        return;

      axios.delete(
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/orders/${this.paymentOrderId}/refund`,
        {
          data: { "userId": this.user['id'] }//Who request this refund?
        }
      )
      .then(response => {
        this.$notify({
          text: `Refund has been requested (order ${this.paymentOrderId}). It will be processed in a while.`,
          type: 'warn'
        });
        //FIXME: Refresh the transactional history after 3 seconds.
        setTimeout(() => {
          this.fetchTransactionHistory();
        }, 3000);
      })
      .catch(err => {
        this.$notify({
          text: `Cannot request for refund (order ${this.paymentOrderId}). `
            + `The banking system may be still processing the transaction, please try again some time later.`,
          type: 'error', duration: 10000
        });
      });
    },
  },

  data() {
    return {
      loading: false,

      order: { },
      transactions: [ ],

      showRequestContext: false,

      expansion: {
        detail: {
          show: false,
          context: { }
        }
      }
    }
  },

  computed: {
    transactionSchema() {
      return [
        { value: 'payment_order_id', text: this.$t('views.dialogOrderDetail.paymentOrderId') },
        { value: 'transaction_id', text: this.$t('views.dialogOrderDetail.transactionId') },
        { value: 'bank_transaction_id', text: this.$t('views.dialogOrderDetail.bankTransactionId') },
        { value: 'amount', text: '$' },
        { value: 'status', text: this.$t('views.dialogOrderDetail.status') },
        { value: 'status_code', text: this.$t('views.dialogOrderDetail.code') },
        { value: 'message', text: this.$t('views.dialogOrderDetail.message') },
        { value: 'created_at', text: this.$t('views.dialogOrderDetail.time') }
      ];
    },

    user() {
      return this.$store.getters.user;
    }
  },

  watch: {
    'paymentOrderId': {
      immediate: false,
      handler(id) {
        if (id && id.length) {
          this.fetchPaymentOrderInfo();
          this.fetchTransactionHistory();
        }
      }
    }
  }
}
</script>